var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-field-suggest" }, [
    _vm.title
      ? _c("h5", { staticClass: "custom-field-suggest__title" }, [
          _vm._v(" " + _vm._s(_vm.title) + " "),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "custom-field-suggest__main" },
      [
        _vm.loading
          ? _c("PtIcon", {
              staticClass: "custom-field-suggest__main-loading",
              attrs: { icon: "SolidLoadingBars" },
            })
          : _vm.nodata
          ? _c(
              "div",
              { staticClass: "custom-field-suggest__main-nodata" },
              [
                _c("PtIcon", {
                  staticClass: "custom-field-suggest__main-nodata-icon",
                  attrs: { icon: "SolidNoDataTip" },
                }),
                _c(
                  "span",
                  { staticClass: "custom-field-suggest__main-nodata-label" },
                  [_vm._v(_vm._s(_vm.$t("smartSearch.nodata")))]
                ),
              ],
              1
            )
          : _c("div", [
              _c(
                "div",
                [
                  _vm.isOptionField
                    ? _c(
                        "ul",
                        { staticClass: "custom-field-suggest__main-option" },
                        _vm._l(_vm.displayList, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.option_id,
                              staticClass:
                                "custom-field-suggest__main-option-item",
                              on: {
                                click: function ($event) {
                                  return _vm.onSelectField(item)
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getHighlightName(item.option_text)
                                  ),
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.isLayerField
                    ? _c("PtVirtualTree", {
                        ref: "tree",
                        staticClass: "custom-field-suggest__main-layer",
                        attrs: {
                          "node-key": "id",
                          "item-class": "custom-field-suggest__main-layer-node",
                          data: _vm.displayList,
                          "default-expand-all": true,
                          "item-min-item-size": 32,
                          "item-size-dependencies": function () {
                            return ["height"]
                          },
                          filter: _vm.stem,
                          "filter-node-method": _vm.filterLayerNode,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var node = ref.node
                              var data = ref.data
                              var isExpand = ref.isExpand
                              var isShowExpandIcon = ref.isShowExpandIcon
                              var toggleNodeExpand = ref.toggleNodeExpand
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-field-suggest__main-layer-item",
                                    style: {
                                      marginLeft: (node.level - 1) * 20 + "px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-field-suggest__main-layer-item__icon",
                                      },
                                      [
                                        isShowExpandIcon
                                          ? _c("PtIcon", {
                                              staticClass:
                                                "item__icon parent-item",
                                              attrs: {
                                                icon: isExpand
                                                  ? "SolidDropdownOpen"
                                                  : "SolidDropdownRight",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return toggleNodeExpand(node)
                                                },
                                              },
                                            })
                                          : _c("PtIcon", {
                                              staticClass:
                                                "item__icon child-item",
                                              attrs: { icon: "SolidSmallDot" },
                                            }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-field-suggest__main-layer-item__label",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSelectField(node.data)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "PtTextTruncate",
                                          { attrs: { tag: "span", lines: 2 } },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getHighlightName(
                                                    data.name
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "empty",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-field-suggest__main-nodata",
                                  },
                                  [
                                    _c("PtIcon", {
                                      staticClass:
                                        "custom-field-suggest__main-nodata-icon",
                                      attrs: { icon: "SolidNoDataTip" },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "custom-field-suggest__main-nodata-label",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("smartSearch.nodata"))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      })
                    : _c(
                        "ul",
                        { staticClass: "custom-field-suggest__main-common" },
                        _vm._l(_vm.displayList, function (item) {
                          return _c(
                            "li",
                            {
                              key: item.value,
                              staticClass:
                                "custom-field-suggest__main-common-item",
                              on: {
                                click: function ($event) {
                                  return _vm.onSelectField(item)
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "custom-field-suggest__main-common-item__value",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getHighlightName(item.value)
                                  ),
                                },
                              }),
                              item.desc
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "custom-field-suggest__main-common-item__desc",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.desc[_vm.lang]) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                ],
                1
              ),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }